import { render, staticRenderFns } from "./FaqMain.vue?vue&type=template&id=534db26e&"
import script from "./FaqMain.vue?vue&type=script&lang=js&"
export * from "./FaqMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports